module.exports = __webpack_public_path__ + "img/brush.be5030ca.webp";